import { ROUTES } from "../../common/constants";
import { clauseCheckDocStatus } from "../vscDashboard/constants";
import {
  BulkClauseTableData,
  BulkClauseTableEntity,
  BulkSummaryTableData,
  BulkSummaryTableEntity,
  ContractTableData,
  ContractTableEntity,
  UserManagementTable,
  VerticalTableData,
  VerticalTableEntity,
} from "./model";
import { ANTD_TABLE_ENTITIES } from "../../components/AntdTable/AntdTable.constants";

export const TableTypes = {
  REVIEW_PENDING_DASHBOARD: "review_pending_dashboard",
  REVIEW_PENDING: "review_pending",
  REVEIW_COMPLETED: "review_completed",
  BULK_CLAUSE_DASHBOARD: "bulk_clause_dashboard",
  BULK_CLAUSE: "bulk_clause",
  USER_MANAGEMENT: "user_managment",
  BULK_SUMMARY: "bulk_summary",
  VERTICAL_MANAGEMENT: "vertical_management",
};

export const ReviewTypes = {
  PENDING_REVIEW: "Contract Review",
  COMPLETED_REVIEW: "Review Completed",
};

export const manageContractsConfig = {
  [ReviewTypes.PENDING_REVIEW]: {
    headerText: ReviewTypes.PENDING_REVIEW,
    tooltipText: "Contracts pending review.",
    entity: ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_PENDING,
  },
  [ReviewTypes.COMPLETED_REVIEW]: {
    headerText: ReviewTypes.COMPLETED_REVIEW,
    tooltipText: "Contracts that have completed review.",
    entity: ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_COMPLETED,
  },
};

export const TableUrlMap = {
  [ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_PENDING]: ReviewTypes.PENDING_REVIEW,
  [ANTD_TABLE_ENTITIES.CONTRACT_REDLINING_COMPLETED]:
    ReviewTypes.COMPLETED_REVIEW,
};

export const SORT = {
  ASC: "ASC",
  DESC: "DESC",
};

export const PaginationActions = {
  FIRST: "First",
  PREVIOUS: "Previous",
  NEXT: "Next",
  LAST: "Last",
};

export const TABLECELL = {
  TOOLTIP: "tooltip",
  BADGE: "badge",
  PILL: "pill",
  VENDORANDDOC: "vendorAndDocType",
  STRING: "string",
  USER_ROLES: "userRoles",
  USER_ACTIONS: "userActions",
  POWER_USER: "powerUser",
  CONTRACT_ID_TOOLTIP: "contractIdTooltip",
  USER_PROFILE: "userProfile",
  ACTIVE_TOGGLE: "activeToggle",
  ACTION_ICON: "actionIcon",
};

export const hiddenOptionsForManageTable = ["Vendor", "Title", "Contract ID"];

export const tableConfiguration: any = {
  [TableTypes.REVIEW_PENDING_DASHBOARD]: {
    dataObject: ContractTableData,
    dataEntity: ContractTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "file",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      // {
      //   title: "Contract ID",
      //   key: "contractId",
      //   type: TABLECELL.CONTRACT_ID_TOOLTIP,
      //   withSorting: false,
      // },

      {
        title: "Contract Type",
        key: "contractType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      // {
      //   title: "Start Date",
      //   key: "startDate",
      //   type: TABLECELL.STRING,
      //   withSorting: false,
      // },
      // {
      //   title: "End Date",
      //   key: "endDate",
      //   type: TABLECELL.STRING,
      //   withSorting: false,
      // },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.REVIEW_PENDING]: {
    dataObject: ContractTableData,
    dataEntity: ContractTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "file",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract Type",
        key: "contractType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.REVEIW_COMPLETED]: {
    dataObject: ContractTableData,
    dataEntity: ContractTableEntity,
    withSorting: false,
    toBeRetrived: 10,
    preventResetPath: ROUTES.manageContracts,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorName",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Contract Name",
        key: "file",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract Type",
        key: "contractType",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },
    ],
    paginationType: "default",
  },
  [TableTypes.BULK_CLAUSE_DASHBOARD]: {
    dataObject: BulkClauseTableData,
    dataEntity: BulkClauseTableEntity,
    withSorting: false,
    preventResetPath: ROUTES.bulkClauseCheck,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorWithType",
        type: TABLECELL.VENDORANDDOC,
        withSorting: false,
      },

      {
        title: "Contract Name",
        key: "title",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },

      {
        title: "Status",
        key: "status",
        type: TABLECELL.PILL,
        withSorting: false,
      },
    ],
    paginationType: "advance",
    polingInterval: 1500,
  },
  [TableTypes.BULK_CLAUSE]: {
    dataObject: BulkClauseTableData,
    dataEntity: BulkClauseTableEntity,
    withSorting: false,
    preventResetPath: ROUTES.bulkClauseCheck,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorWithType",
        type: TABLECELL.VENDORANDDOC,
        withSorting: false,
      },

      {
        title: "Title",
        key: "title",
        type: TABLECELL.TOOLTIP,
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        withSorting: false,
      },
      {
        title: "Start Date",
        key: "startDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "End Date",
        key: "endDate",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "MTC",
        key: "mtc",
        type: TABLECELL.STRING,
        withSorting: false,
      },

      {
        title: "Status",
        key: "status",
        type: TABLECELL.PILL,
        withSorting: false,
      },
    ],
    paginationType: "advance",
    polingInterval: 1500,
  },
  [TableTypes.BULK_SUMMARY]: {
    dataObject: BulkSummaryTableData,
    dataEntity: BulkSummaryTableEntity,
    withSorting: true,
    preventResetPath: ROUTES.clauseSummary,
    tableColumns: [
      {
        title: "Vendor",
        key: "vendorWithType",
        type: TABLECELL.VENDORANDDOC,
        category: "Vendor",
        withSorting: false,
      },

      {
        title: "Title",
        key: "title",
        type: TABLECELL.TOOLTIP,
        category: "Title",
        withSorting: false,
      },

      {
        title: "Contract ID",
        key: "contractId",
        type: TABLECELL.CONTRACT_ID_TOOLTIP,
        category: "Contract ID",
        withSorting: false,
      },
      {
        title: "SLA Penalties/Earn Backs",
        key: "earnBack",
        type: TABLECELL.BADGE,
        category: "SLA Penalties/Earn Back",
        withSorting: true,
      },

      {
        title: "Volume Discounts",
        key: "volumeDiscount",
        type: TABLECELL.BADGE,
        category: "Volume Discounts",
        withSorting: true,
      },

      {
        title: "Investments",
        key: "investments",
        type: TABLECELL.BADGE,
        category: "Non-EPP Investments",
        withSorting: true,
      },
      {
        title: "Productivity Improvements",
        key: "prodImprove",
        type: TABLECELL.BADGE,
        category: "Productivity Improvements",
        withSorting: true,
      },
      {
        title: "Buffer/Bench Recommendations",
        key: "benchRecommendation",
        type: TABLECELL.BADGE,
        category: "Committed Buffer/Bench Pool",
        withSorting: true,
      },
      {
        title: "Overtime / On-Call & Hourly Bill Rates",
        key: "overtime",
        type: TABLECELL.BADGE,
        category: "Overtime/On-call & Holiday Bill Rates",
        withSorting: true,
      },
    ],
    paginationType: "advance",
    polingInterval: 4000,
  },
  [TableTypes.VERTICAL_MANAGEMENT]: {
    dataObject: VerticalTableData,
    dataEntity: VerticalTableEntity,
    paginationType: "advance",
    toBeRetrived: 10,
    preventResetPath: ROUTES.verticalManagement,
    tableColumns: [
      {
        title: "Vertical Name",
        key: "name",
        type: TABLECELL.STRING,
      },
      {
        title: "Source Drive Link",
        key: "drive_link",
        type: TABLECELL.TOOLTIP,
      },
      // {
      //   title: "Destination Drive Link",
      //   key: "destination_drive_link",
      //   type: TABLECELL.TOOLTIP,
      // },
      {
        title: "Active",
        key: "is_enabled",
        type: TABLECELL.ACTIVE_TOGGLE,
      },
      {
        title: "Sync Status",
        key: "sync_status",
        type: TABLECELL.STRING,
      },
      {
        title: "Last Sync Completed At",
        key: "last_sync_completed_at",
        type: TABLECELL.STRING,
      },
      {
        title: "Next Sync At",
        key: "next_sync_at",
        type: TABLECELL.STRING,
      },
      {
        title: "Action",
        key: "action",
        type: TABLECELL.ACTION_ICON,
      },
    ],
  },
  [TableTypes.USER_MANAGEMENT]: {
    dataObject: UserManagementTable,
    paginationType: "advance",
    preventResetPath: ROUTES.adminDashboard,
    tableColumns: [
      {
        title: "Name",
        key: "profileDetails",
        type: TABLECELL.USER_PROFILE,
        withSorting: false,
      },
      {
        title: "Email ID",
        key: "email",
        type: TABLECELL.STRING,
        withSorting: false,
      },
      {
        title: "Role",
        key: "roles",
        type: TABLECELL.USER_ROLES,
        withSorting: false,
      },
      // {
      //   title: "Power User",
      //   key: "powerUser",
      //   type: TABLECELL.POWER_USER,
      //   withSorting: false,
      // },
      {
        title: "\u00A0",
        key: "actions",
        type: TABLECELL.USER_ACTIONS,
        withSorting: false,
      },
    ],
  },
};

export const reviewPendingApiProp = {
  doc_status: TableTypes.REVIEW_PENDING,
};
export const reviewCompletedApiProps = {
  doc_status: "review_completed",
};

export const downloadStatusesforLatestUpload = [
  clauseCheckDocStatus.CLAUSE_CHECK_READY,
];

export const downloadStatuses = [
  clauseCheckDocStatus.CLAUSE_CHECK_READY,
  clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,
];

export const clauseSummaryApiProps = {
  clause_status: [
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
    clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,
  ],
};
export const clauseSummaryApiPropsForLatestUpload = {
  clause_status: [clauseCheckDocStatus.CLAUSE_CHECK_READY],
};
